module.exports = "Ici une note\r\n"